"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineLocaleServices = void 0;
exports.defineLocaleService = defineLocaleService;
exports.defineGfaLocalService = defineGfaLocalService;
const gfa_locale_service_1 = require("@volkswagen-onehub/gfa-locale-service");
function defineLocaleService(config) {
    return {
        id: "locale-service",
        create: () => ({
            "1.2.0": () => ({ featureService: config }),
        }),
    };
}
function defineGfaLocalService() {
    return {
        id: gfa_locale_service_1.id,
        dependencies: {
            featureServices: {
                "locale-service": "^1.2.0",
            },
        },
        create: (env) => {
            const localeService = env.featureServices["locale-service"];
            return {
                "1.0.0": () => ({
                    featureService: localeService,
                }),
            };
        },
    };
}
const defineLocaleServices = (config) => [
    defineGfaLocalService(),
    defineLocaleService(config),
];
exports.defineLocaleServices = defineLocaleServices;
//# sourceMappingURL=index.js.map